import { jsx as _jsx } from "react/jsx-runtime";
import { ColorTheme } from '../../KbLabFront';
import './Button.scss';
export const Button = ({ children, className, colorTheme = ColorTheme.white, show = true, signal, fluid, inline, centered, defaultWidth, href, title, disabled, onClick }) => {
    if (!show) {
        return null;
    }
    const clsx = [
        'kb-button',
        className !== null && className !== void 0 ? className : '',
        fluid ? 'fluid' : '',
        defaultWidth ? 'default-width' : '',
        disabled ? 'disabled' : '',
        signal ? 'signal' : '',
        inline ? 'inline' : '',
        centered ? 'centered' : ''
    ].filter((c) => c !== '').join(' ');
    return disabled ? _jsx("span", { className: clsx, title: title, children: _jsx("span", { className: "caption", children: children }) })
        : _jsx("a", { className: clsx, href: href, onClick: onClick, title: title, children: _jsx("span", { className: "caption", children: children }) });
};
